import script from "./SubTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./SubTitle.vue?vue&type=script&setup=true&lang=js"

import "./SubTitle.vue?vue&type=style&index=0&id=14fc973e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fc973e"]])

export default __exports__